const deferralReasons = [
  { label: "Age", value: "age" },
  { label: "Weight", value: "weight" },
  { label: "Medical reason", value: "medical_reason" },
  { label: "HIV behavior", value: "hiv_behavior" },
  { label: "Pulse", value: "pulse" },
  { label: "BP", value: "bp" },
  { label: "Hb", value: "hb" },
  { label: "Blood vessels", value: "blood_vessels" },
  { label: "Menstruation period", value: "menstruation" },
  { label: "TTI", value: "tti" },
  { label: "Under bled (Non remplis)", value: "under_bled" },
  { label: "Others", value: "others" },
];

export default deferralReasons;
